import { useLayoutEffect, useState } from "react"
import { status_load, status_info } from "../data"
import Loading from "../loading/loading"

import statusStyle from "./status.module.css"
import registerStyle from "../register/register.module.css"
import managerStyle from "manager/manager.module.css"

import { useOffcanvas } from "offcanvas/provider"


export default function Status() {

    const statusList = window.EventManager.statusList
    const gradeList = window.EventManager.gradeList
    const todayYear = window.EventManager.todayYear
    const todayMonth = window.EventManager.todayMonth
    const statusToggle = window.EventManager.statusToggle
    const Set_statusToggle = window.EventManager.Set_statusToggle
    const selectEevent = window.EventManager.selectEevent
    const searchYear = window.EventManager.searchYear
    const searchMonth = window.EventManager.searchMonth

    const [searchDay, Set_searchDay] = useState('')
    const [searchWord, Set_searchWord] = useState('')

    const [statusLoading, Set_statusLoading] = useState(true)
    const [listLoading, Set_listLoading] = useState(false)

    const [pageSetup, Set_pageSetup] = useState({
        'page': 1,
        'limit': 20,
    })

    const { offcanvas_open } = useOffcanvas()

    useLayoutEffect(() => {
        if(statusToggle === true) {
            let day = `${todayYear}-${String(todayMonth + 1).padStart(2, '0')}`
            if(searchYear !== null && searchMonth !== null) {
                day = `${searchYear}-${String(searchMonth + 1).padStart(2, '0')}`
            }

            if(searchDay === '') {
                Set_searchDay(day)
            }
            else {
                day = searchDay
            }

            Set_statusLoading(true)

            get_data(day)
        }
        else {
            Set_searchDay('')
        }
    }, [statusToggle, selectEevent, pageSetup])

    async function get_data(day) {
        const check = await status_load({
            search_day: day,
            search_word: searchWord,
            page_setup: pageSetup
        })
        if(check) {
            Set_statusLoading(false)
        }
    }

    async function get_info(props) {
        const user_id = props['user_id']

        const data = await status_info({
            user_id: user_id
        })

        if(data) {
            console.log(data)
            offcanvas_open(data)
        }
    }

    useLayoutEffect(() => {
        Set_listLoading(false)
    }, [statusList])

    return(
        <div
            id="status"
            className={statusStyle['statusWrap']}
            style={{
                display: statusToggle ? 'flex' : 'none'
            }}
        >
            <Loading
                loading={statusLoading}
            ></Loading>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px"
                }}
            >
                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['secondary']}
                    `}
                    style={{
                        width: "70px",
                        height: "30px"
                    }}
                    onClick={() => Set_statusToggle(false)}
                >닫기</button>

                <div
                    style={{
                        display: "flex",
                    }}
                >
                    <div
                        className={registerStyle['input_date']}
                        style={{
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px"
                        }}
                    >
                        <input
                            type="month"
                            value={searchDay}
                            onInput={(e) => Set_searchDay(e.currentTarget.value)}
                        ></input>
                    </div>

                    <div
                        className={registerStyle['input_text']}
                        style={{
                            width: "300px",
                            borderLeft: "0px",
                            borderRight: "0px",
                            borderRadius: "0px"
                        }}
                    >
                        <input
                            type="text"
                            value={searchWord}
                            placeholder="이름 또는 연락처"
                            onInput={(e) => Set_searchWord(e.currentTarget.value)}
                        ></input>
                    </div>

                    <button
                        type="button"
                        className={statusStyle['button']}
                        style={{
                            width: "70px",
                            height: "30px"
                        }}
                        onClick={() => {
                            Set_listLoading(true)
                            status_load({
                                search_day: searchDay,
                                search_word: searchWord,
                                page_setup: pageSetup
                            })
                        }}
                    >검색</button>
                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto"
                }}
            >
                <Loading
                    loading={listLoading}
                ></Loading>

                <table className={statusStyle['table']}>
                    <thead>
                        <tr>
                            <th style={{width: "5%"}}>번호</th>
                            <th style={{width: "10%"}}>행사</th>
                            <th style={{width: "10%"}}>일정</th>
                            <th style={{width: "10%"}}>이름</th>
                            <th style={{width: "10%"}}>연락처</th>
                            <th style={{width: "5%"}}>성별</th>
                            <th style={{width: "5%"}}>학년</th>
                            <th style={{width: "3%"}}>재원</th>
                            <th style={{width: "10%"}}>가격</th>
                            <th style={{width: "3%"}}>결제</th>
                            <th style={{width: "5%"}}>프로모션</th>
                            <th style={{width: "5%"}}>부가정보</th>
                            <th style={{width: "10%"}}>예약일</th>
                            <th style={{width: "5%"}}>상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        {statusList !== null &&
                        statusList['rows']
                        .map((value, index) => {
                            return(
                                <tr
                                    key={index}
                                    onClick={() => get_info({
                                        user_id: value['id']
                                    })}
                                >
                                    <td>{statusList['count'] - index - (pageSetup['page'] - 1) * pageSetup['limit']}</td>
                                    <td>{value['Schedule']['Event']['name']}</td>
                                    <td>{value['Schedule']['title']}</td>
                                    <td>{value['studentName']}</td>
                                    <td>{value['parentPhone']}</td>
                                    <td>{value['studentGender']}</td>
                                    <td>
                                        {function() {
                                            const grade = gradeList.find(x => x['Mcode'].trim() === value['studentGrade'])
                                            if(grade) {
                                                return grade['McodeName']
                                            }
                                            else {
                                                return ''
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['isEnrolled']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            let payment = value['Schedule']['payment']
                                            if(payment === 0) {
                                                payment = '무료'
                                            }
                                            else {
                                                payment = Number(payment).toLocaleString()
                                            }

                                            return payment
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['paid']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['promotion']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>
                                        {function() {
                                            if(value['hasResponse']) {
                                                return '●'
                                            }
                                        }()}
                                    </td>
                                    <td>{value['Schedule']['targetDate']} {value['Schedule']['targetTime']}</td>
                                    <td>
                                        {function() {
                                            if(value['status'] === 1) {
                                                return '신청'
                                            }
                                            else {
                                                return '취소'
                                            }
                                        }()}
                                    </td>
                                    {/* <td>
                                        {function() {
                                            return value['createdAt'].replace('T', ' ').substring(0, 16)
                                        }()}
                                    </td> */}
                                </tr>
                            )
                        })}

                        {statusList !== null &&
                        statusList['count'] === 0 &&
                            <tr>
                                <td
                                    colSpan={14}
                                    style={{
                                        height: "300px"
                                    }}
                                >자료가 없습니다.</td>
                            </tr>
                        }
                    </tbody>
                    <tfoot></tfoot>
                </table>
            </div>

            <div className={statusStyle['paginationWrap']}>
                <div className={statusStyle['pageWrap']}>
                    {statusList !== null &&
                        Array
                        .from({length: Math.ceil(statusList['count']/pageSetup['limit'])})
                        .map((value, index) => {
                            return(
                                <div
                                    key={index}
                                    className={`
                                        ${statusStyle['page']}
                                        ${pageSetup['page'] === index + 1 ? statusStyle['select'] : null}
                                    `}
                                    onClick={() => {
                                        Set_pageSetup((preState) => {
                                            preState['page'] = index + 1
                                            return {...preState}
                                        })
                                    }}
                                >{index + 1}</div>
                            )
                        })
                    }
                </div>

                <div className={statusStyle['limit']}>
                    <select
                        value={pageSetup['limit']}
                        onChange={(e) => {
                            Set_pageSetup((preState) => {
                                preState['limit'] = Number(e.currentTarget.value)
                                return {...preState}
                            })
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </select>
                </div>
            </div>
        </div>
    )
}